import { atomWithReset } from "jotai/utils";

export const vtourAnnotationsLengthAtom = atomWithReset(0);
